import { useEffect } from 'react';
import { Button, DialogContainer, DialogFooter, DialogHeader, Processing } from '@wg/wows-react-uikit';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { loadAppData } from '~/Actions/ActionApp';
import { hideDialog } from '~/Actions/ActionCategory';
import ContainerView from '~/Containers/ContainerView';
import { KEY_CODE } from '~/helpers/consts';
import dwhExport from '~/helpers/dwhExport';
import { t } from '~/helpers/localization';
import { IResponse } from '~/interfaces';
import { State } from '~/Reducers';

import { default as globalStyles } from '../styles/global.scss';

interface IState {
    response: IResponse;
    promoWidget: any;
    isErrorLoad: boolean;
}

const stateSelector = (state: State): IState => {
    return {
        response: state.ReducerApp.response,
        promoWidget: state.ReducerApp.promoWidget,
        isErrorLoad: state.ReducerApp.isErrorLoad,
    };
};

const ContainerApp = () => {
    const dispatch = useDispatch();
    const appState = useSelector<State, IState>(stateSelector, shallowEqual);

    useEffect(() => {
        dispatch(loadAppData());

        dwhExport.appStart();

        document.addEventListener('keydown', (event) => {
            if (event.keyCode === KEY_CODE.ESC) {
                dispatch(hideDialog());
            }
        });
    }, []);

    if (appState.isErrorLoad) {
        return (
            <div className={globalStyles.dialogWrap}>
                <DialogContainer>
                    <DialogHeader noUnderline={true}>{t('Произошла ошибка, пожалуйста, повторите попытку позже')}</DialogHeader>
                    <DialogFooter>
                        <Button onClick={() => dispatch(loadAppData())}>{t('Обновить')}</Button>
                    </DialogFooter>
                </DialogContainer>
            </div>
        );
    } else if (!appState.response) {
        return <Processing isFetching={true} />;
    }

    return <ContainerView isNeedToShowWelcomePage={false} />;
};

export default ContainerApp;
